// https://babeljs.io/docs/en/next/babel-preset-env#usebuiltins-entry
import 'regenerator-runtime/runtime';

import angular from 'angular';
import LogRocket from 'logrocket';


import fetchApiConfig from './fetchApiConfig';

import io from '../sails.io.config';
window.io = _.merge(window.io, io);
import AppModule from '../app';

fetchApiConfig()
  .then((config) => {
    const environmentIsLocal = !PRODUCTION;
    const { id, name, email, kind } = config.user;
    if (!environmentIsLocal || config.logRocket) {
      console.info('Initializing Logrocket');
      LogRocket.init('petrocloud/pcapp', { release: config.appVersion });
      LogRocket.identify(id, {
        name,
        kind,
        email
      });
      window.addEventListener('unhandledrejection', ({ reason }) => {
        reason && LogRocket.captureException(
          reason,
          { tags: { kind: 'Unhandled' } }
        );
      });
    }
    if (!environmentIsLocal) {
      const [first, last] = name.split(' ');
      _.merge(window.beamer_config, {
        product_id: 'rUCliTXC18891',
        filter: kind, // Serve Beamer news specific to user kind
        user_id: id,
        user_email: email,
        user_firstname: first,
        user_lastname: last,
        selector: '.beamer-button'
      });
      window.Beamer?.init(); // Undefined if/when external script is blocked by browser
    }

    // Store appConfig globally to reference without needing Angular DI of appConfig constant
    window.appConfig = config;


    angular.module(AppModule)
      .constant('appConfig', config);


    angular.bootstrap(document, [AppModule], { strictDi: true });
  })
  .catch(console.error);
